(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-blocks-organics"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
        $('.tab-content').hide();
        $('.plus-wrapper').click(function () {
            $(this).next().slideToggle(200);
            $(this).toggleClass("expanded");
        });
        $('.tab-content').slideUp(200);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builder-accordion-blocks"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
        $('.tab-content').hide();
        $('.plus-wrapper').click(function () {
            $(this).next().slideToggle(200);
            $(this).toggleClass("expanded");
        });
        $('.tab-content').slideUp(200);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builder-accordion-carousel"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
    $('.tab-content').hide();
    $('.plus-wrapper').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
    });
    $('.tab-content').slideUp(200);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builder-faq"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function () {
        $('.answer').hide();
        $('.question-heading').click(function () {
            $(this).next().slideToggle(200);
            $(this).toggleClass("expanded");
        
        });
        $('.answer').slideUp(200);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builder-icon-grid"] && !Shopify.designMode) return;
  try {
    
    function resizeHandler() {
        if ($(window).width() < 1024) {
            $('.icon-hover-style .js-tab-content').hide();
            $('.icon-hover-style .js-tab-content').slideUp(200);
        } else{
            $('.icon-hover-style .js-tab-content').css('display', '');
            $('.icon-hover-style .js-tab-content').removeClass("expanded");
        }
    }
    resizeHandler();
    $(window).resize(resizeHandler);
    $('.icon-hover-style .icon-box').click(function () {
        if ( $(window).width() < 1024 ) {
            $(this).children('.js-tab-content').slideToggle(200);
            $(this).toggleClass("expanded");
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
$(document).ready(function () {
    $('.child').hide();
    $('.js-parent-li a').click(function (e) {
      $this = $(this).parent('.js-parent-li');
      e.preventDefault();
      $this.next('.child').slideToggle(200);
      $this.toggleClass("expanded");
    });
    $('.child').slideUp(200);


    $('ul.grandchild').hide();
    $('.js-has-grandchildren > a').click(function (e) {
      $this = $(this).parent('.js-has-grandchildren');
      e.preventDefault();
      $this.children('ul.grandchild').slideToggle(200);
      $this.toggleClass("expanded");
    });
    $('ul.grandchild').slideUp(200);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});

  } catch(e) { console.error(e); }
})();
})();
